import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { BusinessRole } from 'src/constants/user';
import { PeoStaffPagePeoAdmin } from 'src/pages/peoStaff';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    accessRoles: [BusinessRole.PeoSuperAdmin, BusinessRole.PeoAdmin],
    element: <PeoStaffPagePeoAdmin />,
  },
];

export const PEO_STAFF_ROUTE: RouteProps = {
  path: appRoutes.peoStaff.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [BusinessRole.PeoSuperAdmin, BusinessRole.PeoAdmin],
};
